/**
 * @description  错题集--学生端
 * @author lwb
 */

const state = {
  // 错题集题目
  wrongQuestionsList: () => [],
  // 重练结果
  retrainResult: [],
  // 抽题题目
  randomQuestion: [],
};
const getters = {};
const mutations = {
  // 设置错题题目列表
  setWrongQuestionsList(state, options) {
    state.wrongQuestionsList = options;
  },
  // 设置重练结果
  setRetrainResult(state, result) {
    state.retrainResult = result;
  },
  // 设置抽题题目
  setRandomQuestion(state, list) {
    state.randomQuestion = list;
  },
};
const actions = {};

export default { state, getters, mutations, actions };
